import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const ArrowLeftAlt: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 24, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <path fillRule="evenodd" clipRule="evenodd" d="M13.1213 5.29289C13.5118 5.68342 13.5118 6.31658 13.1213 6.70711L8.82843 11H18C18.5523 11 19 11.4477 19 12V12C19 12.5523 18.5523 13 18 13H8.82843L13.1213 17.2929C13.5118 17.6834 13.5118 18.3166 13.1213 18.7071C12.7308 19.0976 12.0976 19.0976 11.7071 18.7071L5 12L11.7071 5.29289C12.0976 4.90237 12.7308 4.90237 13.1213 5.29289Z" fill={color} />
</svg>);
export default ArrowLeftAlt;

